<template>
    <div class="container66" v-if="mainElement != null">

    <a :href="'#'" v-scroll-to="elementName"
        :style="app.currentConfiguration.stage === 4 ? 'cursor:pointer' : 'cursor:default'"
    >

        <div :style="inverted ? '-webkit-transform: scaleX(-1);  transform: scaleX(-1);' :''">
            <!-- IMAGES -->

            <!-- soporte -->
            <img class="img66" :src="require('@/assets/images/gamas/66/soporte_horizontal.png')" />

            <!-- bandeja -->
            <img class="img66" :src="require('@/assets/images/gamas/66/bandeja.png')" />

            <!-- 2 comp -->
            <img
                class="img66"
                :src="require('@/assets/images/gamas/66/compartimentos2.png')"
                v-if="mainElement['opcion_compartimento'].value && mainElement['opcion_compartimento'].value.num_value==2"
            />

            <!-- 3 comp -->
            <img
                class="img66"
                :src="require('@/assets/images/gamas/66/compartimentos3.png')"
                v-if="mainElement['opcion_compartimento'].value && mainElement['opcion_compartimento'].value.num_value==3"
            />

            <!-- 4 comp -->
            <img
                class="img66"
                :src="require('@/assets/images/gamas/66/compartimentos4.png')"
                v-if="mainElement['opcion_compartimento'].value && mainElement['opcion_compartimento'].value.num_value==4"
            />

            <!-- tapa -->
            <img
                class="img66"
                :src="require('@/assets/images/gamas/66/tapa.png')"
                v-if="mainElement['opcion_tapa'].value && mainElement['opcion_tapa'].value.id=='s'"
            />

        </div>
        <div
            class="text-left textParamFontSize"
            :class="[app.currentConfiguration.stage === 3 && !dontShowTextParams ? 'd-block d-lg-none' : '',
                     app.currentConfiguration.stage === 4 ? 'd-block' : '',
                     dontShowTextParams ? 'd-none' : '']"
            :style="'left:' + leftParamDimensiones + '; top:' + topParamDimensiones"
            style="position: absolute; width:100px;"
        >{{mainElement['dimensiones'].valueString}}</div>
        <div
            class="text-left textParamFontSize"
            :class="[app.currentConfiguration.stage === 3 && !dontShowTextParams ? 'd-block d-lg-none' : '',
                     app.currentConfiguration.stage === 4 ? 'd-block' : '',
                     dontShowTextParams ? 'd-none' : '']"
            :style="'left:' + leftParamDimensiones  + '; top:' + topParamBandejaLisaOPerf"
            style="position: absolute; width:100px"
        >{{mainElement['opcion_base'].valueString}}
        </div>

    </a>


    </div>
</template>

<style scoped lang="scss">
 .textParamFontSize{
     font-size: 95%;
 }
.bandeja-66-item-dimensiones {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
}
.img66 {
    position: absolute;
    top: 0;
    left: -38px;
    height: 200px;
    width: 200px;
    position: absolute;
    overflow: hidden;
}

.container66 {
    height: 200px;
    width: 200px;
    position: relative;
}
</style>

<script>
import jQuery from "jquery";
import Vue from "vue";
import { app } from "../../application.js";

export default {
    name: "mainElement66Component",

    data() {
        return {
            app: app
        };
    },

    props: {
        mainElement: null,
        inverted: false,
        dontShowTextParams: false,
        elementName: ''
    },

    components: {},
    computed: {
        leftParamBandejaLisaOPerf: function () {
            if (this.inverted) {
                return "85px";
            } else {
                return "35px";
            }
        },
        topParamBandejaLisaOPerf: function () {
            if (this.inverted) {
                return "30px";
            } else {
                return "30px";
            }
        },
        leftParamDimensiones: function () {
            if (this.inverted) {
                return "85px";
            } else {
                return "35px";
            }
        },
        topParamDimensiones: function () {
            if (this.inverted) {
                return "10px";
            } else {
                return "10px";
            }
        },
    },
    methods: {},
};
</script>